import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { DefaultButton } from 'design-system';
import { MouseEvent, ReactNode } from 'react';
import { IdeaIcon } from '../../Icons';

const border18props = 'solid 18px transparent';

const useStyles = makeStyles(() => ({
  content: {
    width: 360,
    backgroundColor: '#F5FAFF',
    marginTop: 20,
    marginRight: -20,
    border: '1px solid #2496E8',
    borderRadius: '10px',
    paddingTop: 22,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 15,
    position: 'absolute',
    top: 25,
    zIndex: 1100,
    boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.15)',
  },
  arrow: {
    width: 0,
    height: 0,
    position: 'absolute',
    top: 25,
    borderRight: '20px solid transparent',
    borderBottom: '20px solid #2496E8',
    borderLeft: '20px solid transparent',
    '&::before': {
      content: '""',
      width: 0,
      height: 0,
      position: 'absolute',
      borderTop: border18props,
      borderBottom: 'solid 19px #F5FAFF',
      borderLeft: border18props,
      borderRight: border18props,
      top: -16,
      left: -18,
    },
    zIndex: 1100,
  },
  titleText: {
    fontSize: 17,
    fontWeight: 700,
  },
  informationText: {
    marginTop: 10,
    fontSize: 17,
    fontWeight: 400,
    textAlign: 'left',
  },
  button: {
    marginTop: 10,
  },
}));

type Props = {
  title: string;
  information: string;
  onUnderstood: () => void;
  children: ReactNode;
  open?: boolean;
  rightContentAlign?: number;
  leftArrowAlign?: number;
};

const InformationPopper = ({
  children,
  information,
  onUnderstood,
  title,
  open,
  rightContentAlign = 0,
  leftArrowAlign = -10,
}: Props): JSX.Element => {
  const classes = useStyles();
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onUnderstood();
  };

  if (!open) {
    return <>{children}</>;
  }
  return (
    <Box
      data-testid="information-popper-component"
      sx={{ position: 'relative' }}
    >
      <Box data-testid="children-container">{children}</Box>

      <Box className={classes.content} sx={{ right: rightContentAlign }}>
        <Grid container>
          <Grid item xs={12} container alignItems="center">
            <Box sx={{ marginRight: 5 }}>
              <IdeaIcon />
            </Box>
            <Typography className={classes.titleText}>{title}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.informationText}>
              {information}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="flex-end"
            className={classes.button}
          >
            <Box
              onClick={handleClick}
              id="sales-web-button-understood"
              data-testid="understod-btn"
            >
              <DefaultButton variant="outlined">¡Entendido!</DefaultButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.arrow} sx={{ left: leftArrowAlign }} />
    </Box>
  );
};

export default InformationPopper;
